import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { SuburbanBanner } from '../../components/SuburbanBanner';
import { trackScrollOnBanner } from '../../components/SuburbanBanner/tracking';
import { IState } from '../../store';

export const SuburbanBannerContainer: React.FC = () => {
  const { offer, agent } = useSelector((state: IState) => state.offerData);

  const handleBannerViewed = React.useCallback(() => {
    trackScrollOnBanner({ offer, agent });
  }, [offer, agent]);

  return (
    <ActionAfterViewed callback={handleBannerViewed}>
      <SuburbanBanner />
    </ActionAfterViewed>
  );
};

SuburbanBannerContainer.displayName = 'SuburbanBannerContainer';
